var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReinvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 16.3198C20.7239 16.3198 20.5 16.096 20.5 15.8198V5.99999C20.5 5.17157 19.8284 4.49999 19 4.49999H7.37836C7.10222 4.49999 6.87836 4.27614 6.87836 3.99999C6.87836 3.72385 7.10222 3.49999 7.37836 3.49999H19C20.3807 3.49999 21.5 4.61928 21.5 5.99999V15.8198C21.5 16.096 21.2761 16.3198 21 16.3198Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2439 7.66667H5.43903C4.88674 7.66667 4.43903 8.11439 4.43903 8.66667V18C4.43903 18.5523 4.88674 19 5.43903 19H17.2439C17.7962 19 18.2439 18.5523 18.2439 18V8.66667C18.2439 8.11439 17.7962 7.66667 17.2439 7.66667ZM5.43903 6.66667C4.33446 6.66667 3.43903 7.5621 3.43903 8.66667V18C3.43903 19.1046 4.33446 20 5.43903 20H17.2439C18.3485 20 19.2439 19.1046 19.2439 18V8.66667C19.2439 7.5621 18.3485 6.66667 17.2439 6.66667H5.43903Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1955 7.66667L11.3414 13.2811L5.48736 7.66667L17.1955 7.66667ZM12.0336 14.0028C11.6467 14.3739 11.0361 14.3739 10.6492 14.0028L4.79518 8.38839C4.1449 7.76473 4.58635 6.66667 5.48736 6.66667H17.1955C18.0965 6.66667 18.538 7.76473 17.8877 8.38839L12.0336 14.0028Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinvite);
export default __webpack_public_path__ + "static/media/reinvite.009770acc5c46d43b1fe34829210f97d.svg";
export { ForwardRef as ReactComponent };